import { AccountCountryNames } from '@/pages/account/constants';
import AccountService from '@/pages/account/service';

export default class AddressModalService {
  static get addressForm() {
    return document.getElementById('address-modal').querySelector('form');
  }

  static get accountBody() {
    return document.querySelector('.account-body');
  }

  static get mainLoader() {
    return document.querySelector('.main-loader');
  }

  static ResetAddressForm() {
    const defaultCountry = 'United States';
    const inputFields = AddressModalService.addressForm.querySelectorAll(
      'input:not([type="hidden"])'
    );
    inputFields.forEach((input) => {
      input.value = '';
    });

    const country =
      AddressModalService.addressForm.querySelector('#AddressCountry');
    country.value = defaultCountry;
    let event = new Event('change', { bubbles: true });
    country.dispatchEvent(event);

    AddressModalService.addressForm.querySelector(
      '#address-submit-btn'
    ).dataset.addressId = '';
    AddressModalService.addressForm.querySelector(
      '#address-submit-btn'
    ).disabled = false;

    const errorInputs = AddressModalService.addressForm.querySelectorAll(
      '.address-error-text-input'
    );
    errorInputs.forEach((input) => {
      input.remove();
    });

    let setAsDefaultCheckbox = AddressModalService.addressForm.querySelector(
      '#address_default_address'
    );
    setAsDefaultCheckbox.checked = false;
    setAsDefaultCheckbox.dispatchEvent(new Event('change'));
  }

  static AddFormListeners() {
    if (AddressModalService.addressForm) {
      AccountService.addEventListenersToRequiredInputTextFields(
        AddressModalService.addressForm
      );

      let setAsDefaultCheckbox = AddressModalService.addressForm.querySelector(
        '#address_default_address'
      );
      let submitButton = AddressModalService.addressForm.querySelector(
        '#address-submit-btn'
      );
      setAsDefaultCheckbox.addEventListener('change', function (event) {
        const disclaimerMessageElem =
          AddressModalService.addressForm.querySelector('#disclaimer_message');
        if (event.target.checked) {
          disclaimerMessageElem.classList.remove('hide');
          submitButton.classList.add('open-confirmation-modal');
        } else {
          disclaimerMessageElem.classList.add('hide');
          submitButton.classList.remove('open-confirmation-modal');
        }
      });
    }
  }

  static PopulateFormWithAddress(addressObj) {
    const isTaxIdAddress = ['MX'].includes(addressObj.country_code);
    const taxIdWrapper =
      AddressModalService.addressForm.querySelector('.taxIdField');

    if (isTaxIdAddress) {
      taxIdWrapper.style.display = 'flex';

      const taxIdField =
        AddressModalService.addressForm.querySelector('#TaxId');
      const taxIdFromAttributes = addressObj?.order_attributes?.find(
        (x) => x.name === 'tax_id'
      )?.value;

      taxIdFromAttributes && (taxIdField.value = taxIdFromAttributes);
    } else {
      taxIdWrapper && (taxIdWrapper.style.display = 'none');
    }

    const formFields = {
      first_name:
        AddressModalService.addressForm.querySelector('#AddressFirstName'),
      last_name:
        AddressModalService.addressForm.querySelector('#AddressLastName'),
      company: AddressModalService.addressForm.querySelector('#AddressCompany'),
      address1:
        AddressModalService.addressForm.querySelector('#AddressAddress1'),
      address2:
        AddressModalService.addressForm.querySelector('#AddressAddress2'),
      city: AddressModalService.addressForm.querySelector('#AddressCity'),
      zip: AddressModalService.addressForm.querySelector('#AddressZip'),
      phone: AddressModalService.addressForm.querySelector('#AddressPhone')
    };

    for (const [key, field] of Object.entries(formFields)) {
      field.value = addressObj[key] || '';
    }

    let country =
      AddressModalService.addressForm.querySelector('#AddressCountry');
    country.value = AccountCountryNames[addressObj.country_code];
    let event = new Event('change', { bubbles: true });
    country.dispatchEvent(event);
    let province =
      AddressModalService.addressForm.querySelector('#AddressProvince');
    province.value = addressObj.province;

    let submitButton = AddressModalService.addressForm.querySelector(
      '#address-submit-btn'
    );
    submitButton.dataset.addressId = addressObj.id;
  }

  static HideMainLoader() {
    AddressModalService.accountBody.classList.remove('hide');
    AddressModalService.mainLoader.style.display = 'none';
  }

  static ShowMainLoader() {
    AddressModalService.accountBody.classList.add('hide');
    AddressModalService.mainLoader.style.display = 'block';
    document.documentElement.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
}
